import * as v from 'valibot';

export const LanguageDataScheme = v.object({
  keys: v.record(v.string()),
  locale: v.string(),
  generated: v.string(),
  name: v.string(),
});

export type TLanguageData = v.Output<typeof LanguageDataScheme>;
